
import React, { Component, createContext } from "react";
import { getUserRole } from "../services/firebase";
import { onAuthStateChanged, getAuth } from "firebase/auth";

export const UserContext = createContext({ user: null, role: null });
class UserProvider extends Component {
  state = {
    user: null,
    role: null
  };

    componentDidMount = async () => {
        const auth = getAuth();
        onAuthStateChanged(auth, async (user) => {
            if (user) {
                const role = await getUserRole(user.uid);
                this.setState({ user, role });
            } else {
                this.setState({ user: null, role: null });
            }
        });
  };

  render() {
    const { user, role } = this.state;

    return (
      <UserContext.Provider value={{ user, role }}>
        {this.props.children}
      </UserContext.Provider>
    );
  }
}
export default UserProvider;
